<template>
   <div class="adminPage">
      <div class="titlePage">
         Gestión Portal Iceberg - Empleado
      </div>
      <div class="adminCard">
         <div class="adminCardBody">
            <button
               class="btn btn-primary"
               @click="showModal = true"
               >
            Actualizar Contraseña
            </button>
         </div>
      </div>
      <!-- MODAL -->
      <div v-if="showModal" class="modalOverlay">
         <div class="modalCard">
            <div class="modalHeader">
               <h3>Actualizar Contraseña</h3>
               <button
                  class="modalClose"
                  @click="showModal = false"
                  >
               ✕
               </button>
            </div>
            <div class="modalBody">
               <label class="formLabel">
               Ingrese el usuario
               </label>
               <input
                  v-model="inputText"
                  type="text"
                  class="formInput"
                  />
               <button
                  class="btn btn-primary btn-block"
                  @click="validateInput"
                  >
               Enviar
               </button>
               <div
                  v-if="validationMessage"
                  class="alertMessage"
                  >
                  {{validationMessage}}
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
// Importa el componente de Vuex
import IberoHelpers from '@/store/helpers.js'

export default {

  data () {
    return {
      inputText: '', // Para almacenar el texto ingresado
      validationMessage: '', // Para almacenar el mensaje de validación
      showModal: false, // Para controlar la visibilidad del modal
      userExistObject: {
        existe: '',
      },
    }
  },
  methods: {

    async validateInput () {
      if (!this.inputText) {
        this.validationMessage = 'Por favor, ingrese un usuario.'
        this.autoHideMessage()
        return
      }
      try {
        let response = await IberoHelpers.GetUserPortalEmpleadoIceberg(this.$store, this.inputText)
        this.userExistObject = response.data
        if (response.data.cuentA_ICEBERG != 'NOT_FOUND') {
          this.updatePassword()
        } else {
          this.validationMessage = 'El usuario no existe.'
          this.autoHideMessage()
        }
      } catch (error) {
        console.error('Error loading data:', error)
      }
    },

    // Método para actualizar la contraseña (por hacer)
    validationMessageFunc (text) {
      this.validationMessage = text
    },

    // Método para actualizar la contraseña (por hacer)
    updatePassword () {
      this.validationMessage = 'Se actualizó la contraseña. Por favor revise su correo electrónico.'
      this.autoHideMessage()
    },

    // Método para crear un usuario
    createUser () {
      // Lógica para la creación de usuario
      console.log('Crear usuario')
    },

    autoHideMessage () {
      setTimeout(() => {
        this.validationMessage = ''
      }, 3000) // 5000 milisegundos = 5 segundos
    },

  },
}
</script>